import React, { useEffect, useState } from "react";
import "./Courses.css";
import { isLoggedIn, getToken } from "../utils/auth";
import API_BASE from "../config";

function Courses() {
  const [courses, setCourses] = useState([]);
  const [userCourses, setUserCourses] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/courses.php`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setCourses(data.courses);
        } else {
          console.error("Failed to fetch courses:", data.message);
        }
      })
      .catch((err) => console.error("Error fetching courses:", err));

    if (isLoggedIn()) {
      fetch(`${API_BASE}/profile.php`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success && data.courses) {
            setUserCourses(data.courses.map((c) => c.title));
          }
        })
        .catch((err) => console.error("Error fetching user courses:", err));
    }
  }, []);

  return (
    <div className="courses-page">
      <h2 className="section-title">Our Courses</h2>

      <div className="courses-grid">
        {courses.map((course) => {
          const purchased = userCourses.includes(course.title);

          const imageUrl = course.image.startsWith("http")
            ? course.image
            : `https://visnology.com${course.image}`;

          return (
            <div className="course-card" key={course.id}>
              <img src={imageUrl} alt={course.title} className="course-image" />

              <h2>{course.title}</h2>

              <div className="pricing">
                <span className="original">₹{course.originalPrice}</span>
                <span className="offer">₹{course.offerPrice}</span>
              </div>

              <p className="duration">{course.duration}</p>

             <div className="btns-grid">

              {purchased ? (
                <button
                  className="buy-btn"
                  onClick={() =>
                    (window.location.href = `/videos?course=${course.id}`)
                  }
                >
                  Access Videos
                </button>
              ) : (
                <button
                  className="buy-btn"
                  onClick={() =>
                    (window.location.href = `/buy/${course.id}/${course.offerPrice}`)
                  }
                >
                  Buy Now
                </button>
              )}

              <button
                className="buy-btn"
                onClick={() =>
                  (window.location.href = `/course/${course.slug}`)
                }
              >
                View Details
              </button>

            </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Courses;
